import { fun_PostAction, fun_GetAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 默认关闭
      dialogVisible: false,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        projectName: null, // 项目名称
        identityFlag: null // 身份标识
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "projectName",
          placeholder: "请输入",
          clearable: true
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "projectName",
          isShow: true
        },
        {
          label: "中标价/合同额（万元）",
          prop: "bidPrice",
          align: "right"
        },
        {
          label: "招标类别",
          prop: "tenderClassName"
        },
        {
          label: "业绩承接方式",
          prop: "tenderTypeName"
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [] // 勾选数组
    };
  },
  // 接收父组件传递的数据
  props: {
    // 身份标识
    identityFlag: {
      type: String
    }
  },

  // 模板编译完成
  mounted() {},
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/regPersonAchievement/chooseList", {
          ...this.form,
          ...this.reqPageData,
          identityFlag: this.identityFlag // 身份标识
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_AchievementSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面业绩主键
        this.$parent.form.achievementId = e.val.id;
        // 赋值父页面业绩项目名称
        this.$parent.form.projectName = e.val.projectName;
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    }
  }
};
